import { memo } from "react";
import { Icon } from "@chakra-ui/react";
export const PacmanIcon = memo((props) => (<Icon viewBox="0 0 24 24" {...props}>
    <path fill="currentColor" d="M19.391 15.062a8 8 0 1 1 0-6.123L12 12l7.391 3.062Z"/>
  </Icon>));
//# sourceMappingURL=Pacman.jsx.map